import { RequestBoostedPriorityEnum, RequestPriorityEnum, RequestStatusEnum } from './options-values.constants';

export interface RequestPriorityColors {
  backgroundColor: string;
  backgroundSecondaryColor?: string;
  color: string;
}

export const RequestPriorityColors: { [key: string]: RequestPriorityColors } = {
  [RequestBoostedPriorityEnum.Critical]: {
    backgroundColor: '#F9DAE3',
    color: '#C2315C',
  },
  [RequestBoostedPriorityEnum.VeryHigh]: {
    backgroundColor: '#FEE6D8',
    color: '#DA5922',
  },
  [RequestPriorityEnum.HighPriority]: {
    backgroundColor: '#E8DDFB',
    color: '#6434B3',
  },
  [RequestPriorityEnum.MediumPriority]: {
    backgroundColor: '#D4EFEE',
    color: '#098C84',
  },
  [RequestPriorityEnum.LowPriority]: {
    backgroundColor: '#EBEBEB',
    color: '#5D5D5D',
  },
};

// The current priority in the priority dropdown of the request list: «Selected» of the design's dropdown list item
export const RequestPrioritySelectedOptionColor = '#FCF4F4';

export const RequestStatusColors: { [key: string]: RequestPriorityColors } = {
  [RequestStatusEnum.Open]: {
    backgroundColor: '#EAF2FC',
    backgroundSecondaryColor: '#F5F8FE',
    color: '#3179E3',
  },
  [RequestStatusEnum.Closed]: {
    backgroundColor: '#FEF2EC',
    backgroundSecondaryColor: '#FFF9F5',
    color: '#DA5922',
  },
  [RequestStatusEnum.Declined]: {
    backgroundColor: '#EAF7F6',
    backgroundSecondaryColor: '#FFF9F5',
    color: '#098C84',
  },
  [RequestStatusEnum.OnApproval]: {
    backgroundColor: '#EAF7F6',
    backgroundSecondaryColor: '#FFF9F5',
    color: '#098C84',
  },
};

export const RequestOverdueColors: RequestPriorityColors = {
  backgroundColor: '#FCECF1',
  backgroundSecondaryColor: '#FDF6F8',
  color: '#C2315C',
};
